import Phaser from 'phaser';
import { COLORS } from 'helpers/constants';
import { showLevelEditorMenu } from './LevelEditorMenu';

const { LIGHT_YELLOW } = COLORS;
const menuSize = {
  w: 848,
  h: 500
};

export const setMyLevels = scene => {
  const menuOpen =
    scene.loadLevelMenuContainer &&
    scene.loadLevelMenuContainer.scene &&
    scene.loadLevelMenuContainer.alpha;
  console.log(
    'menu open:',
    scene.loadLevelMenuContainer,
    scene.loadLevelMenuContainer && scene.loadLevelMenuContainer.alpha
  );
  if (menuOpen) {
    showLevelItems(scene);
  }
};

export const showLoadLevelModal = (scene, selectLevel) => {
  console.log('showing load level modal...');
  scene.loadLevelSelectLevel = selectLevel;
  scene.loadLevelMenuContainer = scene.add.container();
  scene.loadLevelMenuContainer.setDepth(20);
  //backdrop
  scene.loadBackdropRect = new Phaser.Geom.Rectangle(
    0,
    0,
    scene.game.canvas.width,
    scene.game.canvas.height
  );
  scene.loadBackdrop = scene.add.graphics();
  scene.loadBackdrop.fillStyle(0x1f272c, 0.5);
  scene.loadBackdrop.fillRectShape(scene.loadBackdropRect);
  scene.loadBackdrop.setInteractive(
    scene.loadBackdropRect,
    Phaser.Geom.Rectangle.Contains
  );
  scene.loadBackdrop.on('pointerup', (pointer, x, y, evt) => {
    if (scene.loadLevelMenuContainer && scene.loadLevelMenuContainer.alpha) {
      hideLoadLevelModal(scene);
      // return to level editor menu if closing from backdrop
      showLevelEditorMenu(scene);
    }
    evt.stopPropagation();
  });
  scene.loadLevelMenuContainer.add(scene.loadBackdrop);

  //menu
  // rounded reactangle graphics for bg:
  scene.loadLevelBG = scene.add.graphics();
  scene.loadLevelBG.fillStyle(0x28363e, 1.0);
  scene.loadLevelBG.lineStyle(3, 0x415762, 1);
  scene.loadLevelBG.fillRoundedRect(
    scene.cameras.main.centerX - menuSize.w / 2,
    scene.cameras.main.centerY - menuSize.h / 2,
    menuSize.w,
    menuSize.h,
    24
  );
  scene.loadLevelBG.strokeRoundedRect(
    scene.cameras.main.centerX - menuSize.w / 2,
    scene.cameras.main.centerY - menuSize.h / 2,
    menuSize.w,
    menuSize.h,
    24
  );
  const menuBgRect = new Phaser.Geom.Rectangle(
    scene.cameras.main.centerX - menuSize.w / 2,
    scene.cameras.main.centerY - menuSize.h / 2,
    menuSize.w,
    menuSize.h
  );
  scene.loadLevelBG.setInteractive(menuBgRect, Phaser.Geom.Rectangle.Contains);
  scene.loadLevelBG.on('pointerup', (pointer, x, y, evt) => {
    evt.stopPropagation();
  });

  scene.loadLevelMenuContainer.add(scene.loadLevelBG);
  // const scale = scene.game.defaultZoom;
  const toggleOrder = (_, __, ___, $event) => {
    scene.loadLevelSortOrder =
      scene.loadLevelSortOrder === 'DESC' ? 'ASC' : 'DESC';
    scene.loadLevelSortToggleLabel.setText('Sort ' + scene.loadLevelSortOrder);
    scene.loadLevelSortToggleCheckbox.setFrame(
      scene.loadLevelSortOrder === 'DESC' ? 0 : 1
    );
    scene.levelItemsContainer.destroy();
    scene.levelItemsContainer = null;
    showLevelItems(scene, selectLevel);

    $event.stopPropagation();
  };
  scene.loadLevelSortOrder = 'ASC';
  scene.loadLevelSortToggleCheckbox = scene.add
    .sprite(
      scene.cameras.main.centerX - menuSize.w / 2 + 25,
      scene.cameras.main.centerY - menuSize.h / 2 + 50,
      'ui_editor_checkbox',
      1
    )
    .setInteractive()
    .on('pointerdown', toggleOrder);
  scene.loadLevelSortToggleLabel = scene.add
    .text(
      scene.cameras.main.centerX - menuSize.w / 2 + 46,
      scene.cameras.main.centerY - menuSize.h / 2 + 50,
      'Sort ' + scene.loadLevelSortOrder,
      {
        fontFamily: 'pixelMix',
        fontSize: '14px',
        color: LIGHT_YELLOW
      }
    )
    .setOrigin(0, 0.5)
    .setInteractive()
    .on('pointerdown', toggleOrder);

  scene.loadLevelFilter = scene.add
    .dom(
      scene.cameras.main.centerX - menuSize.w / 2 + 156,
      scene.cameras.main.centerY - menuSize.h / 2 + 30
    )
    .createFromCache('title_input')
    .setOrigin(0)
    .setPerspective(800)
    .setInteractive()
    .on('pointerdown', (_, __, ___, $event) => $event.stopPropagation());
  scene.loadLevelMenuContainer.add(scene.loadLevelFilter);
  document
    .querySelectorAll('.name-input input')[0]
    .addEventListener('focus', scene.levelScene.disableKeyboardKeys);
  const filter = debounce($event => {
    scene.levelFilter = $event.target.value;
    scene.levelItemsContainer.destroy();
    scene.levelItemsContainer = null;
    showLevelItems(scene, selectLevel);
  });
  document
    .querySelectorAll('.name-input input')[0]
    .addEventListener('keyup', filter);
  document
    .querySelectorAll('.name-input input')[0]
    .addEventListener('blur', scene.levelScene.enableKeyboardKeys);

  scene.loadLevelMenuContainer.add(scene.loadLevelSortToggleCheckbox);
  scene.loadLevelMenuContainer.add(scene.loadLevelSortToggleLabel);

  //content...
  showLevelItems(scene, selectLevel);
};

export const hideLoadLevelModal = scene => {
  console.log('hiding load level modal...');
  scene.loadLevelMenuContainer && scene.loadLevelMenuContainer.destroy();
  scene.loadLevelMenuContainer = null;
  scene.levelItemsContainer = null;
};

const showLevelItems = (scene, selectLevel) => {
  console.log('showing level items...');
  if (!scene.loadLevelMenuContainer || !scene.loadLevelMenuContainer.scene) {
    return;
  }
  const onSelectLevel = selectLevel || scene.loadLevelSelectLevel;
  if (scene.myLevels) {
    const padding = 16;
    if (scene.levelItemsContainer) {
      scene.levelItemsContainer.destroy();
      scene.levelItemsContainer = null;
    }
    scene.levelItemsContainer = scene.add.container(
      scene.cameras.main.centerX - menuSize.w / 2,
      scene.cameras.main.centerY - menuSize.h / 2 + 50
    );
    scene.loadLevelMenuContainer.add(scene.levelItemsContainer);
    //mask
    const maskShape = scene.make.graphics();
    maskShape.fillStyle(0xffffff);
    maskShape.beginPath();
    scene.levelItemsMaskrect = new Phaser.Geom.Rectangle(
      scene.cameras.main.centerX - menuSize.w / 2 + padding,
      scene.cameras.main.centerY - menuSize.h / 2 + padding + 50,
      menuSize.w,
      menuSize.h - 100
    );
    const rect = scene.levelItemsMaskrect;
    maskShape.fillRect(rect.x, rect.y + 20, rect.width, rect.height);
    const mask = maskShape.createGeometryMask();
    scene.levelItemsContainer.setMask(mask);
    //items
    const lvls =
      scene.loadLevelSortOrder === 'DESC'
        ? Object.keys(scene.myLevels).reverse()
        : Object.keys(scene.myLevels);
    lvls
      .map(levelKey => scene.myLevels[levelKey])
      .filter(levelData => {
        if (!levelData || !levelData.name) {
          return false;
        }
        return scene.levelFilter
          ? levelData.name
              .toLowerCase()
              .includes(scene.levelFilter.toLowerCase())
          : true;
      })
      .forEach((levelData, listIndex) => {
        const levelID = levelData.id || levelData.ugcLevelId;
        const width = 400;
        const height = 48;
        const odd = listIndex % 2 === 1;
        const row = Math.floor(listIndex / 2);
        const x = odd ? width + padding * 2 : padding;
        const y = row * height + padding * (row + 1) + 50;
        const bgRect = new Phaser.Geom.Rectangle(x, y, width, height);
        const bg = scene.add.graphics();
        bg.fillStyle(0x1f272c, 0.5);
        bg.fillRectShape(bgRect);
        bg.setInteractive(bgRect, Phaser.Geom.Rectangle.Contains);
        bg.on('pointerdown', pointer => {
          console.log('level selected...', hideLoadLevelModal);
          if (onSelectLevel) {
            onSelectLevel({ ...levelData, id: levelID });
          }
          hideLoadLevelModal(scene);
        });
        scene.levelItemsContainer.add(bg);
        const name = scene.add
          .text(x + padding, y + padding, `${levelData.name}`, {
            fontFamily: 'pixelMix',
            color: LIGHT_YELLOW
          })
          .setOrigin(0);
        scene.levelItemsContainer.add(name);
      });
  } else if (!scene.myLevels) {
    const loading = scene.add
      .text(8, 8, 'Loading Your Levels...', {
        fontFamily: 'pixelMix',
        color: LIGHT_YELLOW
      })
      .setOrigin(0);
    scene.loadLevelMenuContainer.add(loading);
  }
};

export const scrollLoadLevelItems = (scene, dy) => {
  const scale = scene.game.defaultZoom;
  const maskHeight = scene.levelItemsMaskrect.height;
  const itemsHeight =
    (Object.keys(scene.myLevels).length / 2) * ((24 + 8) * scale);

  const max = scene.levelItemsMaskrect.y;
  const min =
    scene.levelItemsMaskrect.y -
    (itemsHeight > maskHeight ? itemsHeight - maskHeight + 100 : maskHeight);
  const nextScroll = scene.levelItemsContainer.y - dy;
  if (nextScroll > min && nextScroll < max) {
    scene.levelItemsContainer.y -= dy;
  }
};

export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
